import React, { useState, useEffect, useMemo } from "react";
import { motion } from "framer-motion";

const ImageSlider: React.FC = () => {
  // 이미지 경로 배열
  const images = useMemo(
    () => [
      "/60image/네잎클로버.png",
      "/60image/강철 검.png",
      "/60image/구름.png",
      "/60image/구슬.png",
      "/60image/금속 방패.png",
      "/60image/꽃다발.png",
      "/60image/꽃잎.png",
      "/60image/나무 가지.png",
      "/60image/나무 잎.png",
      "/60image/나무 줄기.png",
      "/60image/도자기.png",
      "/60image/도토리.png",
      "/60image/돌탑.png",
      "/60image/메탈릭 용.png",
      "/60image/모래시계.png",
      "/60image/바람개비.png",
      "/60image/바위.png",
      "/60image/번데기.png",
      "/60image/벼.png",
      "/60image/별.png",
      "/60image/복주머니.png",
      "/60image/불꽃.png",
      "/60image/불꽃놀이.png",
      "/60image/새벽의 별.png",
      "/60image/새싹.png",
      "/60image/수호 부적.png",
      "/60image/숲.png",
      "/60image/싱그러운 잎.png",
      "/60image/씨앗.png",
      "/60image/열매 바구니.png",
      "/60image/은반지.png",
      "/60image/은빛 초.png",
      "/60image/작은 등불.png",
      "/60image/천칭.png",
      "/60image/초록빛 새싹.png",
      "/60image/캠프파이어.png",
      "/60image/팬던트.png",
      "/60image/풍요로운 잔.png",
      "/60image/항아리.png",
      "/60image/홍등.png",
      "/60image/화로.png",
    ],
    []
  );

  // 현재 보여줄 이미지 인덱스
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  // 다음 이미지로 바뀌기 위해 나가는 중인지 여부
  const [isExiting, setIsExiting] = useState(false);
  // 바꿀 예정인 다음 인덱스 임시 저장
  const [nextIndex, setNextIndex] = useState<number>(0);

  // 5초 간격으로 '현재 이미지 → 사라짐 → 다음 이미지 → 등장' 처리
  useEffect(() => {
    const interval = setInterval(() => {
      let randomIndex;
      do {
        randomIndex = Math.floor(Math.random() * images.length);
      } while (randomIndex === currentIndex); // 연속 중복 방지

      // 먼저 Exit 애니메이션을 시작
      setNextIndex(randomIndex);
      setIsExiting(true);
    }, 5000);

    return () => clearInterval(interval);
  }, [images, currentIndex]);

  // Framer Motion에서 사용될 variants (초기/들어올 때/나갈 때)
  const variants = {
    initial: {
      scale: 0,
      opacity: 0,
    },
    enter: {
      scale: 1,
      opacity: 1,
      y: [0, -10, 0], // 위아래로 둥실둥실
      transition: {
        duration: 1, // scale/opacity가 1이 되는 데 걸리는 시간
        y: {
          duration: 2.5, // 위아래 1 cycle에 걸리는 시간
          repeat: Infinity, // 무한 반복
          repeatType: "reverse",
          ease: "easeInOut",
        },
      },
    },
    exit: {
      scale: 0,
      opacity: 0,
      transition: {
        duration: 1, // 사라지는데 걸리는 시간
      },
    },
  };

  // 나가는 애니메이션이 끝났을 때 호출
  const handleAnimationComplete = (definition: string) => {
    if (definition === "exit") {
      // 실제 이미지를 교체하고 나가는 상태 해제
      setCurrentIndex(nextIndex);
      setIsExiting(false);
    }
  };

  return (
    <div>
      <motion.img
        src={images[currentIndex]}
        alt="Random Slide"
        // 처음에는 "initial" 상태에서 시작 → "enter"로 애니메이션
        initial="initial"
        animate={isExiting ? "exit" : "enter"}
        variants={variants}
        onAnimationComplete={handleAnimationComplete}
        style={{
          backgroundSize: "contain",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "160px",
          height: "160px",
          margin: "auto",
          marginTop: "40px",
          display: "block",
        }}
      />
    </div>
  );
};

export default ImageSlider;
